var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{ref:"multiselect",staticClass:"custom-select",attrs:{"value":_vm.value,"options":Object.keys(_vm.options),"searchable":false,"show-labels":false,"allow-empty":false},on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('span',[_vm._v(_vm._s(_vm.options[option]))])]}},{key:"option",fn:function(ref){
var option = ref.option;
return [_c('span',[_vm._v(_vm._s(_vm.options[option]))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }